module.exports = __webpack_public_path__ + "img/RRR.9351c430.png";